module.exports = __webpack_public_path__ + "static/media/Invert.a7ce10c4.svg";